<template>
  <section
    v-if="rows.length"
    class="cc-sheet cc-sheet--failed"
  >
    <header class="cc-sheet__head">
      <div>
        <h2>{{ $t('convertCoordinates.failed.title') }}</h2>
        <p>{{ $t('convertCoordinates.failed.subtitle', { count: rows.length }) }}</p>
      </div>
    </header>

    <div class="cc-table-scroll">
      <table class="cc-table cc-table--results">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t('convertCoordinates.failed.error') }}</th>
            <th>{{ $t('convertCoordinates.failed.input') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in rows"
            :key="`failed-${row.index}`"
          >
            <td>{{ formatIndex(row.index) }}</td>
            <td>{{ row.error }}</td>
            <td class="cc-raw">
              {{ stringify(row.input) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FailedRowsAlert',
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatIndex(index) {
      if (index === null || index === undefined || index === '') return '—'
      return index
    },
    stringify(input) {
      if (!input) return '—'
      try {
        return JSON.stringify(input)
      } catch (err) {
        return String(input)
      }
    },
  },
}
</script>
